import {Box, Fab, Grid, Link} from "@mui/material"
import {Typography} from "@mui/material";
import logo1 from "../assets/logo1.jpg";
import {useTranslation} from "react-i18next";
import URI from "../constants/URI";
import {useNavigate} from "react-router-dom";


const HomePage = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();

  return (
    <Box sx={{m: 2}}>
      <Grid container justifyContent="center">
        <Grid item container maxWidth={1000}>
          <Grid item xs={12}>
            <Typography variant="h4" sx={{my: 2}}>{t("welcome_lm2")}</Typography>
          </Grid>
          <Grid item container justifyContent="center" xs={12} sx={{mb: 2}}>
            <img src={logo1} alt="LearnersMot2 logo"
                 style={{width: "100%", height: "100%", maxWidth: 250}}/>
          </Grid>
          <Grid item container justifyContent="center">
            <Grid item alignItems="center">
              <Typography align="justify">{t("home_p1")}</Typography>
              <Typography align="justify">{t("home_p1_2")}</Typography>
              <ul>
                <li>{t("catg_work")}</li>
                <li>{t("catg_social")}</li>
                <li>{t("catg_maths")}</li>
                <li>{t("catg_culture")}</li>
                {/*<li>{t("reading_writing")}</li>*/}
                {/*<li>{t("spelling")}</li>*/}
                {/*<li>{t("maths")}</li>*/}
                {/*<li>{t("problem_solving")}</li>*/}
                {/*<li>{t("communication")}</li>*/}
                {/*<li>{t("effective_learning")}</li>*/}
              </ul>
              <Typography align="justify">
                {t("home_p2")}
              </Typography>
              {/*<ol>*/}
              {/*  <li>{t("topic_work")}</li>*/}
              {/*  <li>{t("topic_social")}</li>*/}
              {/*  <li>{t("topic_maths")}</li>*/}
              {/*  <li>{t("topic_culture")}</li>*/}
              {/*</ol>*/}
              <Typography align="justify">
                {t("home_p3")}
              </Typography>
              {/*<Typography align="justify">*/}
              {/*  {t("home_p4")}*/}
              {/*</Typography>*/}
              {/*<Typography align="justify">*/}
              {/*  {t("home_p5")}*/}
              {/*</Typography>*/}
              <Grid container justifyContent="center" sx={{mt: 1}}>
                {window.localStorage.getItem("token") === null ? (
                  <Link variant="h5"
                        onClick={() => navigate(URI.SIGNUP)}>{t("sign_up_exclamation")}</Link>
                ) : (
                  <Link variant="h5" onClick={() => navigate(URI.QUIZ)}>{t("start_quiz")}</Link>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default HomePage;